// extracted by mini-css-extract-plugin
export default {"helpfulWrapper":"helpful_helpfulWrapper__jg6Cc","helpfulTitle":"helpful_helpfulTitle__B3jmJ","yes":"helpful_yes__fR8Cl","no":"helpful_no__PaDtR"};